import { ProductItem } from "../product-item/product-item";

export default new class Category extends ProductItem {
    constructor() {
        super();
        this.category = '[data-category]';
        this.searchPage = '[data-search-page]';

        if (!(document.querySelector(this.category) || document.querySelector(this.searchPage))) return;

    }
}
